import { useEffect, useState } from "react";
import ConfigAPI from "../../services/ConfigAPI";

export default function GeneralSection() {
    const [title, setTitle] = useState("");
    const [baseUrl, setBaseUrl] = useState(window.location.origin);
    const [description, setDescription] = useState("");
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadConfig();
    }, []);

    const loadConfig = async () => {
        try {
            setLoading(true);
            const response = await ConfigAPI.getConfig();
            
            if (response.success) {
                const config = response.data;
                setTitle(config.siteTitle || document.title);
                setDescription(config.siteDescription || "");
            }
        } catch (err) {
            console.error("Erro ao carregar configurações:", err);
            setError("Erro ao carregar configurações");
            
            // Fallback para valores locais
            setTitle(document.title);
            setBaseUrl(window.location.origin);
            const metaDescription = document.querySelector('meta[name="description"]');
            setDescription(metaDescription?.getAttribute("content") || "");
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await ConfigAPI.updateGeneralConfig({
                siteTitle: title,
                siteDescription: description,
                baseUrl: baseUrl
            });

            if (response.success) {
                // Atualizar valores locais também
                document.title = title;
                const metaDescription = document.querySelector('meta[name="description"]');
                if (metaDescription) {
                    metaDescription.setAttribute("content", description);
                }

                setSuccess(true);
                setTimeout(() => setSuccess(false), 3000);
            }
        } catch (err) {
            console.error("Erro ao salvar configurações:", err);
            setError(err.response?.data?.message || "Erro ao salvar configurações");
            setTimeout(() => setError(null), 3000);
        } finally {
            setLoading(false);
        }
    };

    if (loading && !title) {
        return (
            <div className="section-content">
                <h1>Configurações Gerais</h1>
                <div className="config-card">
                    <p style={{ textAlign: 'center', color: '#6b7280' }}>Carregando...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="section-content">
            <h1>Configurações Gerais</h1>

            <div className="config-card">
                <h3>Informações do Site</h3>
                
                {success && (
                    <div className="alert-success">
                        <span>✓ Configurações salvas com sucesso</span>
                    </div>
                )}

                {error && (
                    <div style={{
                        background: '#fee2e2',
                        color: '#dc2626',
                        padding: '1rem',
                        borderRadius: '8px',
                        marginBottom: '1rem',
                        fontWeight: '500'
                    }}>
                        {error}
                    </div>
                )}

                <div className="form-group">
                    <label>Título do Site</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        disabled={loading}
                    />
                </div>

                <div className="form-group">
                    <label>URL Base</label>
                    <input 
                        type="text" 
                        value={baseUrl} 
                        disabled 
                    />
                </div>

                <div className="form-group">
                    <label>Descrição</label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        rows="3"
                        disabled={loading}
                    />
                </div>

                <button 
                    className="btn-save" 
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? "Salvando..." : "Salvar Alterações"}
                </button>
            </div>
        </div>
    );
}